/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Email configuration for challenge-specific communications. Allows custom SendGrid templates per challenge.
 * @export
 * @interface ChallengeEmailConfig
 */
export interface ChallengeEmailConfig {
    /**
     * SendGrid template ID for welcome email when user joins challenge
     * @type {string}
     * @memberof ChallengeEmailConfig
     */
    welcomeEmailTemplateId?: string;
    /**
     * SendGrid template ID for the 6-digit login code email (overrides platform default d-f7f011937c144ab686c9f82beb9b4fd7)
     * @type {string}
     * @memberof ChallengeEmailConfig
     */
    loginCodeEmailTemplateId?: string;
    /**
     * SendGrid template ID for reward notification emails
     * @type {string}
     * @memberof ChallengeEmailConfig
     */
    rewardEmailTemplateId?: string;
    /**
     * SendGrid template ID for challenge completion email
     * @type {string}
     * @memberof ChallengeEmailConfig
     */
    challengeCompleteEmailTemplateId?: string;
    /**
     * Suppress the default DevourPlay welcome email
     * @type {boolean}
     * @memberof ChallengeEmailConfig
     */
    suppressDefaultWelcomeEmail?: boolean;
    /**
     * Suppress the default DevourPlay reward notification email
     * @type {boolean}
     * @memberof ChallengeEmailConfig
     */
    suppressDefaultRewardEmail?: boolean;
}

/**
 * Check if a given object implements the ChallengeEmailConfig interface.
 */
export function instanceOfChallengeEmailConfig(value: object): value is ChallengeEmailConfig {
    return true;
}

export function ChallengeEmailConfigFromJSON(json: any): ChallengeEmailConfig {
    return ChallengeEmailConfigFromJSONTyped(json, false);
}

export function ChallengeEmailConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeEmailConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'welcomeEmailTemplateId': json['welcomeEmailTemplateId'] == null ? undefined : json['welcomeEmailTemplateId'],
        'loginCodeEmailTemplateId': json['loginCodeEmailTemplateId'] == null ? undefined : json['loginCodeEmailTemplateId'],
        'rewardEmailTemplateId': json['rewardEmailTemplateId'] == null ? undefined : json['rewardEmailTemplateId'],
        'challengeCompleteEmailTemplateId': json['challengeCompleteEmailTemplateId'] == null ? undefined : json['challengeCompleteEmailTemplateId'],
        'suppressDefaultWelcomeEmail': json['suppressDefaultWelcomeEmail'] == null ? undefined : json['suppressDefaultWelcomeEmail'],
        'suppressDefaultRewardEmail': json['suppressDefaultRewardEmail'] == null ? undefined : json['suppressDefaultRewardEmail'],
    };
}

export function ChallengeEmailConfigToJSON(json: any): ChallengeEmailConfig {
    return ChallengeEmailConfigToJSONTyped(json, false);
}

export function ChallengeEmailConfigToJSONTyped(value?: ChallengeEmailConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'welcomeEmailTemplateId': value['welcomeEmailTemplateId'],
        'loginCodeEmailTemplateId': value['loginCodeEmailTemplateId'],
        'rewardEmailTemplateId': value['rewardEmailTemplateId'],
        'challengeCompleteEmailTemplateId': value['challengeCompleteEmailTemplateId'],
        'suppressDefaultWelcomeEmail': value['suppressDefaultWelcomeEmail'],
        'suppressDefaultRewardEmail': value['suppressDefaultRewardEmail'],
    };
}

